import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import ImgSlider from "@components/x-slider";
import Image from "@components/image";
import meituanImageUrl from "@shared/core/meituanImageUrl";
import Toolbar from "./toolbar";

const imageProcesor = {
  w: 1500,
  l: 1,
};
const previewImageProcessor = {
  w: 140,
  l: 1,
  Q: 80,
};

class DetailHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgIdx: 0,
      displayList: false,
    };
  }

  render() {
    const product = this.props.product || {};
    const { productMediaInfoList } = product;
    const { displayList } = this.state;
    return (
      <div
        className={cx("media-gallery product-gallery", {
          "product-gallery--display-list": displayList,
        })}
      >
        <div style={{ display: displayList ? "none" : "block" }}>
          <ImgSlider
            slides={[productMediaInfoList[0]]
              .filter(Boolean)
              .map(m => ({ ...m, mediaUrl: meituanImageUrl(m.mediaUrl, imageProcesor) }))}
            displayProgress={false}
            keyMap={{ src: "mediaUrl" }}
          />
        </div>
        <div style={{ display: displayList ? "block" : "none" }}>
          <ImgSlider
            slides={(productMediaInfoList || []).filter(Boolean)}
            displayProgress={true}
            onRenderSlide={function(slide, isCurrent) {
              return [
                <Image key="0" isFull={true} src={meituanImageUrl(slide.mediaUrl, imageProcesor)} loadit={isCurrent} />,
                <span key="1" className="product-gallery__category">
                  {slide.categoryName}
                </span>,
              ];
            }}
            jumpTo={this.state.imgIdx}
            onSwitch={idx => {
              this.setState({
                imgIdx: idx,
              });
            }}
          />
        </div>
        {displayList ? (
          <ul className="product-gallery-list list-unstyled">
            {productMediaInfoList.map((img, idx) => (
              <li
                className="product-gallery-list__item"
                onClick={() => {
                  this.setState({
                    imgIdx: idx,
                  });
                }}
              >
                <img src={meituanImageUrl(img.mediaUrl, previewImageProcessor)} />
                <i>{idx + 1}</i>
              </li>
            ))}
          </ul>
        ) : (
          ""
        )}
        <button
          type="button"
          className="btn product-gallery__display-list-btn"
          onClick={() => {
            this.setState({
              displayList: !displayList,
            });
          }}
        >
          {displayList ? "隐藏" : "显示"}照片列表
        </button>
        <div className="product-header__actions">
          <Toolbar
            isUserFav={this.props.isUserFav}
            productCity={product.addressInfo && product.addressInfo.cityName}
            productId={product.productId}
            productFavCount={product.favCount}
            productPics={productMediaInfoList}
            pwu={this.props.pwu}
          />
        </div>
      </div>
    );
  }
}

DetailHeader.defaultProps = {
  isUserFav: false,
};

DetailHeader.propTypes = {
  product: PropTypes.object.isRequired,
  isUserFav: PropTypes.bool,
  pwu: PropTypes.object,
};

export default DetailHeader;

require("./index.less");
require("./index.less");